<template>
  <div>
    <card id="cardVersao" titulo="Dados anteriores">
      <template #acoes>
        <a class="text-secondary ml-1" href title="Adicionar dado anterior" @click.prevent="addIndicador()">
          <i class="fas fa-plus"></i>
        </a>
      </template>
      <card-table class="table-borderless mb-2" :dragscroll="true" :cardClassName="cardClassName" v-if="versoes.length > 0">
        <thead>
        <tr>
          <th></th>
          <th></th>
          <th v-for="(title, index) in titles" :key="index">{{title.nome}}</th>
        </tr>
        </thead>

        <tbody>

        <tr v-for="(versao, i) in versoes" :key="versao.id">
          <td>
            <v-button class="icon" :run="remove" :params="[versao, i]" :button="false" :popover="true" title="Excluir Versão">
              <i class="fa fa-times"></i>
            </v-button>
          </td>
          <td>
            <v-button class="icon" :run="editarIndicador" :params="[versao]" :button="false" title="Editar Versão">
              <i class="fa fa-edit"></i>
            </v-button>
          </td>
          <td v-for="(title, index) in titles" :key="index">
            <template v-if="title.type === 'boolean'">
              {{versao[title.id] ? 'Sim' : 'Não'}}
            </template>
            <template v-else-if="title.type === 'enum'">
              {{getLabel(versao[title.id], title.options)}}
            </template>
            <template v-else-if="title.type === 'datahora'">
              {{versao[title.id] | datahora}}
            </template>
            <template v-else>
              {{versao[title.id]}}
            </template>
          </td>

        </tr>
        </tbody>

      </card-table>

      <small-loading v-if="loading"></small-loading>

      <div v-if="!versoes.length && !loading" class="alert alert-outline-info">
        Não há dados anteriores para exibir
      </div>

    </card>
    <card class="mt-3" titulo="Alterações no Indicador Real" v-if="atos.length > 0">

      <card-table class="table-borderless mb-2" :cardClassName="cardClassName">
        <thead>
        <tr>
          <th>Ato</th>
          <th v-for="(title, index) in titlesAtos" :key="index">{{title.nome}}</th>
          <th>Registro</th>
        </tr>
        </thead>

        <tbody>

        <tr v-for="ato in atos" :key="ato.id">
          <td>
            <a class="icon" @click.prevent="verAto(ato)">
              {{getCodigo(ato)}}
              <template v-if="ato.titulo">
                - {{ato.titulo}}
              </template>
            </a>
          </td>
          <td v-for="(title, index) in titlesAtos" :key="index">
            <template v-if="['radio', 'boolean'].includes(title.type || title.tipo)">
              {{ato.indicador[title.id] ? 'Sim' : 'Não'}}
            </template>
            <template v-else-if="['select', 'enum'].includes(title.type || title.tipo)">
              {{getLabel(ato.indicador[title.id], title.options)}}
            </template>
            <template v-else-if="title.type === 'datahora'">
              {{ato.indicador[title.id] | datahora}}
            </template>
            <template v-else-if="title.id === 'camposConfrontacoes'">
              <template v-if="ato.indicador[title.id]">
                <div v-for="(registro, idx) in ato.indicador[title.id]" :key="idx">
                  <p>Confrontação: {{ registro.confrontacao }}</p>
                  <p>Metragem: {{ registro.metragem }}</p>
                  <p>Confrontante: {{ registro.confrontante }}</p>
                </div>
              </template>
            </template>
            <template v-else-if="title.id === 'camposArea'">
              <template v-if="ato.indicador[title.id]">
                  <p>Medida Área: {{ ato.indicador[title.id].medidaArea }}</p>
                  <p>Área Total: {{ ato.indicador[title.id].area }}</p>
                  <p v-if="ato.indicador[title.id].fracaoIdealLivre">Fração ideal (livre): {{ ato.indicador[title.id].fracaoIdealLivre }}</p>
                  <p v-if="ato.indicador[title.id].fracaoSolo">Fração solo: {{ ato.indicador[title.id].fracaoSolo }}</p>
                  <p v-if="ato.indicador[title.id].fracaoSoloPercentual">Fração solo (%): {{ ato.indicador[title.id].fracaoSoloPercentual }}</p>
                  <p v-if="ato.indicador[title.id].coeficienteProporcionalidade">Coeficiente de proporcionalidade: {{ ato.indicador[title.id].coeficienteProporcionalidade }}</p>
              </template>
            </template>
            <template v-else-if="title.id === 'camposUnidadesAcessorias'">
              <template v-if="ato.indicador[title.id]">
                <div v-for="(registro, idx) in ato.indicador[title.id]" :key="idx">
                  <p>Descrição: {{ registro.descricao }}</p>
                  <p>Unidade: {{ registro.unidade }}</p>
                  <p>Complemento: {{ registro.complemento }}</p>
                  <p>Área: {{ registro.area }}</p>
                </div>
              </template>
            </template>
            <template v-else-if="title.id === 'camposAreaEdificada'">
              <template v-if="ato.indicador[title.id]">
                <div v-for="(registro, idx) in ato.indicador[title.id]" :key="idx">
                  <p>Descrição: {{ registro.descricao }}</p>
                  <p>Área: {{ registro.area }}</p>
                </div>
              </template>
            </template>
            <template v-else-if="title.id === 'referencias'">
              <template v-if="ato.indicador[title.id]">
                <div v-for="(registro, idx) in ato.indicador[title.id]" :key="idx">
                  <p>{{ nomearOrigemReferencia(registro) }}</p>
                </div>
              </template>
            </template>
            <template v-else-if="title.id === 'registroAnterior'">
              <template v-if="ato.indicador[title.id]">
                <div v-for="(registro, idx) in ato.indicador[title.id]" :key="idx">
                  <p>{{ getLabelRegistroAnterior(registro) }}</p>
                </div>
              </template>
            </template>
            <template v-else-if="title.id === 'registrosVinculados'">
              <template v-if="ato.indicador[title.id]">
                <div v-for="(registro, idx) in ato.indicador[title.id]" :key="idx">
                  <p>{{ nomearFicha(registro) }}</p>
                </div>
              </template>
            </template>
            <template v-else-if="title.id === 'camposTipoImovel'">
              <template v-if="ato.indicador[title.id]">
                {{trataEnumTipoImovel(ato.indicador[title.id]['tipoImovel'])}} {{ato.indicador[title.id]['descricaoTipoImovelOutros'] ? ato.indicador[title.id]['descricaoTipoImovelOutros'] : ''}}
              </template>
            </template>
            <template v-else>
              <div v-html="ato.indicador[title.id]" />
            </template>
          </td>
          <td>
            {{ato.registro | datahora}}
          </td>
        </tr>
        </tbody>

      </card-table>

      <small-loading v-if="loading"></small-loading>

    </card>
  </div>
</template>

<script>
import FrontBusiness from "@/business/FrontBusiness";
import Card from "@/components/Layout/components/Card.vue";
import CardTable from "@/components/Layout/components/CardTable.vue";
import SmallLoading from "@/components/SmallLoading";
import FormIndicadorRealHistorico from "@/components/IndicadorReal/Form/FormIndicadorRealHistorico.vue";
import IndicadorRealHistoricoBusiness from "@/business/indicadores/IndicadorRealHistoricoBusiness";
import Utils from "@/commons/Utils";
import IndicadorRealBusiness from "@/business/indicadores/IndicadorRealBusiness";
import EnderecoBusiness from "@/business/EnderecoBusiness";
import AtoBusiness from "@/business/protocolo/AtoBusiness";
import IndicadorBusiness from "@/business/indicadores/IndicadorBusiness";
import DetalhesAtoRegistrado from "@/components/IndicadorGeneric/Detalhes/DetalhesAtoRegistrado.vue";
import AuditoriaBusiness from "@/business/AuditoriaBusiness";

export default {

  name: "Versões",
  components: {SmallLoading, CardTable, Card},
  props: {
    ficha: Object,
    consulta: Boolean
  },

  data() {

    let title = [
      {"nome": "Versão", "id": "versao"},
      {"nome": "Categoria", "id": "categoria", "type": "enum", "options": IndicadorRealBusiness.getCategorias()},
      {"nome": "Unidade Autônoma", "id": "unidadeAutonoma", "type": "boolean"},
      {"nome": "Tipo de imóvel", "id": "tipoImovel", "type": "enum", "options": IndicadorRealBusiness.getTiposImovel()},
      {"nome": "Descrição do Tipo de Imóvel", "id": "descricaoTipoImovelOutros"},
      {"nome": "Imóvel da União", "id": "imovelUniao", "type": "boolean"},
      {"nome": "Imóvel da Marinha", "id": "marinha", "type": "boolean"},
      {"nome": "Imóvel de Fronteira", "id": "fronteira", "type": "boolean"},
      {"nome": "Número da unidade", "id": "unidade"},
      {"nome": "Bloco", "id": "bloco"},
      {"nome": "Quadra", "id": "quadra"},
      {"nome": "Lote", "id": "lote"},
      {"nome": "Localização", "id": "localizacao"},
      {"nome": "Empreendimento/Condomínio", "id": "empreendimento"},
      {"nome": "Andar", "id": "andar"},
      {"nome": "Pavimento", "id": "pavimento"},
      {"nome": "Grupo (Tipo)", "id": "grupo"},
      {"nome": "Loteamento", "id": "loteamento"},
      {"nome": "Denominação da Área Rural", "id": "denominacao"},
      {"nome": "INCRA (CCIR)", "id": "incra"},
      {"nome": "Código SNCR", "id": "codigoSncr"},
      {"nome": "Medida área", "id": "medidaArea"},
      {"nome": "Área total", "id": "area"},
      {"nome": "Fração ideal (livre)", "id": "fracaoIdealLivre"},
      {"nome": "Medida área DOI", "id": "medidaAreaDoi"},
      {"nome": "Área total DOI", "id": "areaTotalDoi"},
      {"nome": "Fração solo", "id": "fracaoSolo"},
      {"nome": "Fração solo (%)", "id": "fracaoSoloPercentual"},
      {"nome": "Coeficiente de proporcionalidade", "id": "coeficienteProporcionalidade"},
      {"nome": "ITR", "id": "itr"},
      {"nome": "CAR", "id": "car"},
      {"nome": "Certificação no SIGEF", "id": "certificacaoIncra"},
      {"nome": "Cadastro imobiliário", "id": "cadastroImobiliario"},
      {"nome": "Cadastro Imobiliário Brasileiro (CIB)", "id": "cadastroImobiliarioBrasileiro"},
      {"nome": "Cadastro fiscal", "id": "cadastroFiscal"},
      {"nome": "CEP", "id": "cep"},
      {"nome": "Tipo logradouro", "id": "tipoLogradouro"},
      {"nome": "Logradouro (rua)", "id": "logradouro"},
      {"nome": "Número", "id": "numero"},
      {"nome": "Bairro (setor)", "id": "bairro"},
      {"nome": "Cidade", "id": "cidade"},
      {"nome": "Estado", "id": "estado"},
      {"nome": "Complemento", "id": "complemento"},
      {"nome": "ID", "id": "id"},
      {"nome": "Cadastro", "id": "cadastro", "type": "datahora"},
      {"nome": "Atualização", "id": "atualizacao", "type": "datahora"}
    ];

    let titleAto = IndicadorRealBusiness.loadCampos(this.ficha, true);

    return {
      versoes: [],
      atos: [],
      cardClassName: {'card-table-scroll': true},
      titles: title,
      titlesAtos: titleAto,
      loading: true,
      options: {
        tipos: IndicadorRealBusiness.getTiposImovel(),
        categorias: IndicadorRealBusiness.getCategorias(),
        estados: EnderecoBusiness.getEstados(),
      },
    }
  },

  async mounted() {
    await this.load();
  },
  methods: {
    getCodigo: AtoBusiness.getCodigo,
    nomearFicha: FrontBusiness.nomearFicha,
    /**
     * A origem de uma referência na versão. A unidade lida do teor pela análise é TRANSMISSAO sem
     * ficha vinculada (`referenciaDetalhes` nulo): nomear a ficha ali lançava TypeError no render e
     * sumia com a versão inteira. Sem ficha, vale a matrícula de destino digitada, ou traço.
     */
    nomearOrigemReferencia(registro) {
      return FrontBusiness.nomearOrigemReferencia(registro);
    },
    getLabelRegistroAnterior: IndicadorRealBusiness.getLabelRegistroAnterior,
    getLabel: FrontBusiness.getLabel,
    trataEnumTipoImovel: (a) => AuditoriaBusiness.trataEnumTipoImovel(a),

    async load(){
      this.loading = true;
      this.versoes = await IndicadorRealHistoricoBusiness.listarDadosAnteriores(this.ficha.id);
      this.atos = await IndicadorRealBusiness.buscarAtosAlteracaoIndicador(this.ficha.id);

      this.loading = false;
    },

    update(){
      this.$emit('update', this.versoes);
    },
    async remove(versao, i){
      await IndicadorRealHistoricoBusiness.delete(versao.id).then(response => {
        this.versoes.splice(i, 1);
      }).catch(e => FrontBusiness.showError('', e.message));
      this.update();
    },

    async editarIndicador(versao) {
      let retorno = await FrontBusiness.openModal(FormIndicadorRealHistorico, {id: versao.id});
      if(retorno){
        await this.load();
      }
    },

    async addIndicador() {
      let indicador = {};
      this.titles.map(f => {
        indicador[f.id] = Utils.clone(this.ficha[f.id]);
      })
      delete indicador.id;
      indicador.indicadorReal = {id: this.ficha.id, livro: this.ficha.livro};
      indicador.versao = this.versoes[0]?.versao + 1;
      let retorno = await FrontBusiness.openModal(FormIndicadorRealHistorico, {indicador});
      if(retorno){
        await this.load();
      }
    },

    async verAto(ato) {
      let business = IndicadorBusiness.getBusiness(this.ficha?.livro);
      let ficha = await business.getById(this.ficha.id);
      FrontBusiness.openModal(DetalhesAtoRegistrado, {item: ato, ficha: ficha});
    },
  }
}
</script>

<style lang=scss>
.card-table-scroll {
  padding-bottom: 5px !important;

  overflow: auto !important;

  table {
    width: max-content;

    th, td {
      padding: 0.75rem 1rem;
    }
  }
}
</style>
